declare global {
  interface Window {
    _hmt: any[]
    aplus_queue?: Array<{ action: string; arguments: unknown[] }>
  }
}

const shouldEnableAnalytics = () => {
  const hostname = window.location.hostname
  return hostname !== 'localhost' && hostname !== 'pre.lifepage.cc'
}

const appendScript = (id: string, src: string) => {
  if (document.getElementById(id)) {
    return
  }
  const script = document.createElement('script')
  script.async = true
  script.id = id
  script.src = src
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

export default defineNuxtPlugin(() => {
  if (!import.meta.client || !shouldEnableAnalytics()) {
    return
  }

  window._hmt = window._hmt || []
  // 关闭百度统计的自动PV跟踪，交由 analytics.client.ts 中的 router.afterEach 手动接管，防止SPA应用PV翻倍
  window._hmt.push(['_setAutoPageview', false])

  window.aplus_queue = window.aplus_queue || []

  appendScript('hm-baidu', 'https://hm.baidu.com/hm.js?c6c2153275fdc22fa231f8653be59836')
  appendScript('beacon-aplus', 'https://d.alicdn.com/alilog/mlog/aplus/203467608.js')

  window.aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['appKey', '675fbe968f232a05f1d6a9fa']
  })
  window.aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['aplus-waiting', 'MAN']
  })
})
